export default ({ sections }) =>
  sections.entries.find((section) => section.primarySectionForRoute);
